// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "0e1a37bd6c199b3628740fc7c222bc3c" + ".js";
};